<template>
  <div class="modify-pwd-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <h3 class="title">找回密码</h3>
      </div>

      <el-form-item prop="username">
        <div class="label">账号</div>
        <el-input v-model="loginForm.userName" placeholder="账号" name="username" type="text" />
      </el-form-item>

      <el-form-item prop="mobile">
        <div class="label">手机号</div>
        <el-input v-model="loginForm.mobile" placeholder="手机号" name="mobile" type="text" />
      </el-form-item>

      <el-form-item prop="smsCode" class="code">
        <div class="label">验证码</div>
        <el-input v-model="loginForm.smsCode" placeholder="验证码" name="smsCode" type="text" />
        <el-button :disabled="disabledCodeBtn" type="success" @click="doSendCode" v-if="!isCountDown">获取验证码</el-button>
        <div class="count-down" v-else>{{ countDownNumber }}</div>
      </el-form-item>

      <el-form-item prop="password">
        <div class="label">新密码</div>
        <el-input v-model="loginForm.password" type="password" placeholder="新密码" name="password" />
      </el-form-item>

      <el-form-item prop="confirmPassword">
        <div class="label">确认密码</div>
        <el-input v-model="loginForm.confirmPassword" type="password" placeholder="确认密码" name="confirmPassword" />
      </el-form-item>

      <el-button :disabled="disabledSubmitBtn" :loading="loading" type="primary" @click.native.prevent="doModifyPwd">确认修改</el-button>

      <div class="tips">收不到验证码，请拨打4008858821</div>
    </el-form>
    <el-dialog title="图形验证码" :visible.sync="dialogVisible" width="30%" :before-close="cancel">
      <el-form ref="codeForm" :model="codeForm" :rules="codeRules" auto-complete="on" label-position="left" v-loading="codeLoading">
        <el-form-item prop="code" class="code">
          <div class="label">验证码</div>
          <el-input v-model="codeForm.code" placeholder="验证码" name="code" type="text" />
          <div class="img">
            <img :src="codeForm.codeImg" alt @click="getCodeImg" />
          </div>
        </el-form-item>
        <el-form-item class="codeBtn">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="sendPhoneCode('codeForm')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import { modifyPwd, sendSmsCode } from "@/api/login";
import { modifyPwd, getCodeImg, getSmsByVecode } from "@/api/login";

let timer;
export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateSmsCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码必须是8-16个字符"));
      } else {
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码必须是8-16个字符"));
      } else if (value !== this.loginForm.password) {
        callback(new Error("密码和确认密码必须一致"));
      } else {
        callback();
      }
    };
    return {
      isCountDown: false,
      countDownNumber: 60,
      dialogVisible: false,
      codeLoading: false,
      loginForm: {
        userName: "",
        mobile: "",
        smsCode: "",
        password: "",
        confirmPassword: "",
      },
      loginRules: {
        userName: [{ required: true, trigger: "blur", validator: validateUsername }],
        mobile: [{ required: true, trigger: "blur", validator: validateMobile }],
        smsCode: [{ required: true, trigger: "blur", validator: validateSmsCode }],
        password: [{ required: true, trigger: "blur", validator: validatePassword }],
        confirmPassword: [{ required: true, trigger: "blur", validator: validateConfirmPassword }],
      },
      codeForm: {
        code: "",
        codeImg: "",
        sess: "",
      },
      codeRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      loading: false,
    };
  },
  computed: {
    disabledSubmitBtn() {
      return !(
        this.loginForm.userName
        && this.loginForm.password.length >= 8
        && this.loginForm.password.length <= 16
        && this.loginForm.smsCode
        && this.loginForm.password === this.loginForm.confirmPassword
      );
    },
    disabledCodeBtn() {
      return !(this.loginForm.userName && this.loginForm.mobile);
    },
  },
  methods: {
    cancel() {
      this.$refs.codeForm.resetFields();
      this.dialogVisible = false;
    },
    doSendCode() {
      this.dialogVisible = true;
      this.codeForm.code = "";
      this.getCodeImg();
    },
    sendPhoneCode(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            userName: this.loginForm.userName,
            mobile: this.loginForm.mobile,
            veCode: this.codeForm.code,
            sessionId: this.codeForm.sess,
          };
          this.codeLoading = true;
          getSmsByVecode(params).then((res) => {
            this.codeLoading = false;
            if (res.data.error_code === 0) {
              this.dialogVisible = false;
              this.isCountDown = true;
              this.countDownNumber = 60;
              this.$message({
                message: "短信验证码已发送！",
                type: "success",
              });
              timer = setInterval(() => {
                if (this.countDownNumber < 1) {
                  clearInterval(timer);
                  this.countDownNumber = 60;
                  this.isCountDown = false;
                } else {
                  this.countDownNumber -= 1;
                }
              }, 1000);
            } else {
              this.getCodeImg();
            }
          });
        }
      });
    },
    doModifyPwd() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          const params = Object.assign({}, this.loginForm);
          params.password = this.$md5(params.password);
          params.confirmPassword = this.$md5(params.confirmPassword);
          modifyPwd(params).then((res) => {
            if (res.data.error_code === 0) {
              this.$message({
                message: "密码修改成功！",
                type: "success",
              });
              this.$router.push({ path: "/login" });
            }
          });
        }
      });
    },
    getCodeImg() {
      this.codeLoading = true;
      getCodeImg().then((res) => {
        this.codeLoading = false;
        if (res.data.error_code === 0) {
          this.codeForm.codeImg = res.data.data.middleUrl;
          this.codeForm.sess = res.data.data.sess;
        }
      });
    },
  },
};
</script>

<style lang="scss">
/* reset element-ui css */
.modify-pwd-container {
  background-color: #f1f1f1;
  .el-input {
    height: 47px;
    text-align: center;
    input {
      background: transparent;
      border: 1px solid #e8eaec;
      -webkit-appearance: none;
      border-radius: 4px;
      padding: 12px 5px 12px 80px;
      height: 47px;
      width: 430px;
      color: #000;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #000 !important;
      }
    }
  }

  .el-form-item {
    .el-form-item__content {
      .label {
        position: absolute;
        height: 47px;
        line-height: 47px;
        padding: 0 20px;
        color: #666666;
        font-size: 14px;
        z-index: 10;
      }
      .count-down {
        line-height: 47px;
        color: #f95d5b;
        width: 110px;
        text-align: center;
      }
    }
    .el-button--success {
      margin-left: 20px;
    }
    &.code {
      .el-form-item__content {
        display: flex;
        .el-input {
          flex: 3;
          input {
            width: 100%;
          }
        }
        .img {
          padding-left: 14px;
          flex: 1;
          height: 50px;
          img {
            height: 100%;
            width: 133px;
          }
        }
      }
    }
  }
  .codeBtn {
    text-align: right;
    margin-top: 40px;
    margin-bottom: 10px;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.modify-pwd-container {
  min-height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  .login-form {
    position: absolute;
    border-radius: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 530px;
    height: 610px;
    max-width: 100%;
    background-color: #fff;
    padding: 50px;
    overflow: hidden;
    .el-button--primary {
      background-color: #ffa300;
      border: none;
      width: 100%;
      height: 52px;
      border-radius: 6px;
      margin-bottom: 30px;
      &.is-disabled {
        background-color: #e5e5e5;
        color: #a7a7a7;
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #868686;
    text-align: center;
    cursor: pointer;
  }

  .title-container {
    position: relative;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000033;
      margin: 10px auto 30px auto;
      text-align: left;
    }
  }
}
</style>
